<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates7">
<p class="centerImage"><img alt="images" id="plate7" src="images/plate7.jpg"/></p>
<p class="caption">Gerry Edge, right, flight commander with 605 when I joined, later to be CO of 253 Squadron before returning to 605 in late 1941.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates7.vue?db650720